import { IconButton, Stack, Typography } from '@mui/material';
import { Remove } from '@mui/icons-material';
import { VyIcon } from '@vy/ui-design-system';
import React from 'react';
import { vyTheme } from '../../../../../../assets/themes/vyTheme.ts';

type ContractPdfViewerZoomControlsProps = {
  scale: number;
  zoomMin: number;
  zoomMax: number;
  onZoomIn: () => void;
  onZoomOut: () => void;
};

export const ContractPdfViewerZoomControls: React.FC<ContractPdfViewerZoomControlsProps> = ({
  scale,
  zoomMin,
  zoomMax,
  onZoomIn,
  onZoomOut,
}) => {
  const zoomPercentage = Math.round(scale * 100);

  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{
        alignItems: "center",
        position: 'absolute',
        bottom: 16,
        right: 16,
        backgroundColor: 'common.white',
        borderRadius: '999px',
        boxShadow: vyTheme.shadows[2],
        paddingLeft: 1,
        paddingRight: 1,
        paddingTop: 0.5,
        paddingBottom: 0.5
      }}>
      <IconButton
        size="small"
        onClick={onZoomOut}
        disabled={scale <= zoomMin}
        data-vy="contract-pdf-toolbar-zoom-out"
        aria-label="Zoom out"
      >
        <Remove fontSize="small" />
      </IconButton>
      <Typography variant="body2" sx={{ minWidth: 5, textAlign: 'center' }}>
        {zoomPercentage}%
      </Typography>
      <IconButton
        size="small"
        onClick={onZoomIn}
        disabled={scale >= zoomMax}
        data-vy="contract-pdf-toolbar-zoom-in"
        aria-label="Zoom in"
      >
        <VyIcon icon="PlusMedium" />
      </IconButton>
    </Stack>
  );
};
